const getters = {

}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/motivateAccounting/getters.js